/* eslint-disable function-paren-newline */

// See React on Rails Pro documentation for details regarding **.imports-X.** file extension & duplicate file structure.
import loadable from '@loadable/component';
import retry from '../../../utils/retry';

// eslint-disable-next-line import/prefer-default-export
export const PublicEventsCalendar = loadable(() => retry(() => import(
  /* webpackChunkName: "PublicEventsCalendar" */
  './PublicEventsCalendar')));
